// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"c5f529ed","237":"95433255","353":"4e4442f4","376":"647b9721","542":"22b0a0dd","569":"4e9d6fb3","591":"9f6fc328","612":"7396f866","647":"7f91d507","915":"54e3ad0b","999":"50a533a9"}[chunkId] + ".chunk.js";
};